export function buildQueryString(data: object): string {
    const validTypes = ["string", "number", "boolean"];
    return (
        Object.keys(data)
            // @ts-expect-error Check for typing
            .filter((key) => validTypes.includes(typeof data[key]))
            // @ts-expect-error Check for typing
            .map((key) => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
            .join("&")
    );
}
